<div class="vitamui-heading mb-0">
  <app-welcome-message [title]="welcomeTitle()" [message]="welcomeMessage()" [imgUrl]="portalLogoUrl()"></app-welcome-message>
</div>

<div class="vitamui-content">
  <app-content-list [content]="content()"></app-content-list>
  @if (loading()) {
    <mat-spinner class="vitamui-spinner large my-4 mx-auto"></mat-spinner>
  }
</div>
